var map = {
	"./email_active.png": "C0ao",
	"./local_active.png": "RivK",
	"./phone_active.png": "s4DP",
	"./star_active.png": "4H8j"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QR1V";


//////////////////
// WEBPACK FOOTER
// ./src/img/home ^\.\/.*_active\.png$
// module id = QR1V
// module chunks = 8